import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import SlickSlider from 'react-slick';
import { branch, compose, defaultProps, renderComponent, setPropTypes, withProps } from 'recompose';
import 'slick-carousel/slick/slick.css';
import { searchTileType } from '../../../../constants';
import { noCapMap } from '../../../../utils';
import { Icon } from '../../../components';
import Loading from '../../loading';
import ContentTile from './content-tile';
import CourseTile from './course-tile';
import EventTile from './event-tile';
import ShowMoreTile from './show-more-tile';

const ButtonLink = ({ children, link }) => (
  <LinkContainer className='next pushLeft' exact to={link}>
    <Button>
      {children} <Icon icon='chevron-right-large' />
    </Button>
  </LinkContainer>
);

const Slider = compose(
  branch(
    ({ loading }) => loading,
    renderComponent(Loading)
  ),
  branch(
    ({ slides }) => slides.length === 0,
    renderComponent(({ noDataText }) => (
      <p className='no-data'>
        {noDataText}
      </p>
    ))
  )
)(({ maxPreviewSize, settings, slides, showMore, link }) => (
  <SlickSlider {...settings}>
    {
      noCapMap((slide, index) =>
        <Col key={index} xs={12} md={3}>
          {
            slide.type === searchTileType.Event ?
              <EventTile {...slide} /> : null
          }
          {
            slide.type === searchTileType.Course ?
              <CourseTile {...slide} /> : null
          }
          {
            slide.type === searchTileType.Content ?
              <ContentTile {...slide} /> : null
          }
        </Col>
      )(fp.take(maxPreviewSize)(slides))
    }
    {
      showMore ?
        <Col xs={12} md={3}>
          <ShowMoreTile label={showMore} link={link} />
        </Col>
        : null
    }
  </SlickSlider>
));

const SliderSection = ({
  className,
  id,
  heading,
  link,
  linkText,
  slides,
  noDataText,
  maxPreviewSize,
  settings,
  loading,
  hideButtonLink,
  showMore
}) => (
    slides.length > 0 ?
      <section {...{ id: `tiles--${id}`, className }}>
        <Grid>
          <h2 className='keyline'>
            <Link to={link}>{heading}</Link>
            {hideButtonLink ? null : <ButtonLink link={link}>{linkText}</ButtonLink>}
          </h2>
          <Row className='no-gutter row-slider'>
            <Slider {...{
              slides,
              noDataText,
              loading,
              maxPreviewSize,
              settings,
              showMore,
              link
            }} />
          </Row>
        </Grid>
      </section>
      : null
  );

export default compose(
  setPropTypes({
    slides: PropTypes.array.isRequired,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    heading: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    link: PropTypes.string.isRequired,
    linkText: PropTypes.string,
    loading: PropTypes.bool,
    autoPlay: PropTypes.bool,
    infinite: PropTypes.bool,
    hideButtonLink: PropTypes.bool,
    noDataText: PropTypes.string,
    maxPreviewSize: PropTypes.number,
    showMore: PropTypes.string
  }),
  defaultProps({
    autoPlay: true,
    infinite: false,
    maxPreviewSize: 16,
    noDataText: 'There is no data in this section.',
    arrows: true,
    showMore: 'Show More'
  }),
  withProps(({
    autoplay,
    infinite,
    arrows
  }) => ({
    settings: {
      autoplay: autoplay,
      autoplaySpeed: 4000,
      arrows,
      dots: true,
      pauseOnHover: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: infinite,
      accessibility: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            pauseOnHover: true,
            centerMode: true,
            centerPadding: '50px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            pauseOnHover: true,
            centerMode: true,
            centerPadding: '50px'
          }
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            pauseOnHover: true,
            centerMode: true,
            centerPadding: '0px'
          }
        }
      ]
    }
  }))
)(SliderSection);



// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/slider-section.js